import { useCallback, useEffect, useMemo, useState } from 'react'
import { SectionCard } from '../../components/card'
import { Separator } from '../../components/separator'
import { Stepper, StepperItem } from '../../components/stepper'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../redux/hook'
import { proposedHousingTypeItems, stepperItems } from '../../utils/shared-dropdown'
import ApplicationCooLayout from '../../layout/application-coo-layout'
import { ApplicationStep5 } from '../../models/classes/ApplicationStep5.class'
import { useForm } from '../../hooks/use-form'
import { P2Button, P2ButtonGroup, P2TextDescription } from 'react-bootstrap-common-script'
import OwnerOrOccupierReviewAccordion from '../../components/HOC/owner-review-accordion/owner-review-accordion'
import { isArray, size } from 'lodash'
import ReviewDocument from './review-endorse/document'
import ReviewContactDetails from './review-endorse/contact-detail'
import { validateReviewEndorse, validateReviewHoldingOwnerOccupier } from '../../utils/validator'
import { updateFormData } from '../../redux/slices/application-step-5-slice'
import { HoldingFormData, InitIncomingToHoldingFormData } from '../../models/polymer/HoldingFormData.model'
import { ApplicationStep1 } from '../../models/classes/ApplicationStep1.class'
import { updateApplicationStep1FormDataThunk } from '../../redux/slices/application-step-1-slice'
import { TextSubheader } from '../../components/text/text-subheader'
import ReviewHouseholdStructureTable from './review-endorse/review-household-structure-table'
import useSaveDraft from '../../hooks/use-save-draft'
import { Owner } from '../../models/polymer/Owner.model'
import { Occupier } from '../../models/polymer/Occupier.model'
import { updateStageASuccess } from '../../redux/slices/completed-steps-slice'
import useIdleSaveDraft from '../../hooks/use-idle-save-draft'
import DivorceRegistrarRepresentation from './review-endorse/divorce-registrar-representation'
import { OwnershipReasonEnum } from '../../models/enum/ownership-reason.enum'
import { CooSubmission, SubmitFinancing } from '../../models/classes/CooSubmission.class'
import { PolymerAxios } from '../../utils/axios'
import { CooGiveConsent } from '../../models/classes/CooGiveConsent.class'
import { StageBConveyancing } from '../../models/classes/stage-b/review-endorse.class'
import Declaration from './review-endorse/declaration'
import LeavingPageModal from './leaving-page-modal'
import { API_ApplicationRemove, API_ApplicationSubmit,API_EligibilityDebugLog, API_GiveConsent, API_StartConsent } from '../../utils/api'
import { StructureStatusEnum } from '../../models/enum/structure-status.enum'
import { useInitialWindowScrollTo } from '../../hooks/use-initial-window-scroll-to'
import { MyInfo } from '../../models/polymer/MyInfo.model'
import { HoldingOwner } from '../../models/polymer/HoldingOwner.model'
import SaveDraftAlert from '../../components/HOC/stage-a-form/save-draft-alert'
import SaveDraftModal from './save-draft-modal'
import { setBackTriggered } from '../../redux/slices/back-triggered-slice'
import { checkIsFlatResale, checkNeedBypass35YearsOld, convertRaceToEthnicCode } from '../../utils/form-helper'
import { TextInfo } from '../../components/text'
import { HoldingTypeEnum } from '../../models/enum/holding-type.enum'
import TenancyInCommonTable from './review-endorse/tenancy-in-common-table'
import { shared_documents_list } from '../../utils/shared/documents-list'
import { stageATrackingId } from '../../utils/wogaa-ids'
import { customWindow } from '../../models/interfaces/wogaa.interface'
import useCheckRemission from '../../hooks/use-check-remission'
import { SchemeTypeEnum } from '../../models/enum/scheme-type.enum'
import useGetEligibilityOverride from '../../hooks/use-get-eligibility-override'
import { LoanTypeEnum } from '../../models/enum/loan-type.enum'
import { StampDutyValuationEnum } from '../../models/enum/stamp-duty-valuation.enum'

let activeStep = 5;

export interface OutgoingOwnerRepresentedState {
    owner: Owner;
    is_represented?: boolean;
}


function ApplicationCOOStep5() {

  const navigate = useNavigate();
  const AppDispatch = useAppDispatch();
  const { performSaveDraft, performSaveDraftManual } = useSaveDraft();
  useIdleSaveDraft(() => {saveDraft(false)});
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [registrarModalOpen, setRegistrarModalOpen] = useState<boolean>(false);
  const [saveDraftSuccess, setSaveDraftSuccess] = useState<boolean>(false);
  const [saveDraftModalOpen, setSaveDraftModalOpen] = useState<boolean>(false);
  const [outgoingOwnersRepresentedState, setOutgoingOwnersRepresentedState] = useState<OutgoingOwnerRepresentedState[]>([]);
  const loginUser = useAppSelector(state => state.auth.AuthenticationSlice.loginUser);
  const applicationStartFormData = useAppSelector(state => state.app.ApplicationStartSlice.formData);
  const applicationStep1FormData = useAppSelector(state => state.app.ApplicationStep1Slice.formData);
  const applicationStep2FormData = useAppSelector(state => state.app.ApplicationStep2Slice.formData);
  const applicationStep3FormData = useAppSelector(state => state.app.ApplicationStep3Slice.formData);
  const applicationStep4FormData = useAppSelector(state => state.app.ApplicationStep4Slice.formData);
  const applicationStep5FormData = useAppSelector(state => state.app.ApplicationStep5Slice.formData);
  const initApplicationStep5FormData = useAppSelector(state => state.app.ApplicationStep5Slice.formData);
  const applicationId = useAppSelector(state => state.app.ApplicationIdSlice.applicationId);
  const step_4 = useAppSelector(state => state.app.CompletedStepsSlice.stage_a.step_4);
  const loginUserStructureStatus = useAppSelector(state => state.auth.AuthenticationSlice.structureStatus);
  const singpassToken = useAppSelector(state => state.auth.AuthenticationSlice.singpassToken);
  const { bypassPayments } = useGetEligibilityOverride(applicationStartFormData.selected_hdb_property?.hdb_ref);
  const holdingFormAdditionalValues = useMemo(() => {
  return {
     isLoginOutgoing: applicationStep1FormData.household.incoming_owners.every(item => item.myinfo.uinfin !== loginUser.uinfin)
  }
}, [loginUser.uinfin, applicationStep1FormData.household])

  const { values: ReviewEndorseValues, formValid: ReviewEndorseFormValid, setFormValue: ReviewEndorseSetFormValue }: { handleChange: any, values: ApplicationStep5, errors: any, formValid: boolean, setFormValue: (update: ApplicationStep5) => void } = useForm(new ApplicationStep5(), () => { }, validateReviewEndorse);
  const { values: holdingFormValues, errors: holdingFormErrors , formValid:holdingFormValid, setFormValue: holdingSetFormValue }: {values: HoldingFormData, handleChange: any,  errors: any, formValid: boolean, setFormValue: (update: HoldingFormData) => void } = useForm(new HoldingFormData(), () => { }, validateReviewHoldingOwnerOccupier, holdingFormAdditionalValues);

  const { schemeType } = useCheckRemission(applicationStartFormData, applicationStep1FormData,applicationStep2FormData, applicationStep3FormData);

  const onBindOwnerMyInfoToHolding = useCallback((nric: string, myInfoData:MyInfo) => {
    let newHoldingOwners = holdingFormValues?.holding_owners.map(e=>{
      if(e.original_uinfin === nric){
        //Bind only all myinfo but not mobile_no and email, because mobile_no and email will be separate retrieve.
        const ethnicCode = convertRaceToEthnicCode(myInfoData.race);
        let new_holding_owner:HoldingOwner = new HoldingOwner({...e, myinfo: { ...e.myinfo, mobile_no: myInfoData.mobile_no, email: myInfoData.email, race: e.myinfo.race ? e.myinfo.race : ethnicCode }});
        return new_holding_owner;
      }
      else{
        return e;
      }
    })
    holdingSetFormValue({...holdingFormValues, holding_owners: [...newHoldingOwners]});
    
  },[holdingFormValues, holdingSetFormValue]);

  const onUnBindOwnerMyInfoToHolding = useCallback((nric: string) => {

    let foundUser: Owner | undefined = holdingFormValues?.holding_owners?.find(e => e.myinfo?.uinfin === nric);

    let newHoldingOwners = holdingFormValues?.holding_owners.map(e=>{
      if(e.original_uinfin === nric){
        let new_holding_owner:HoldingOwner = new HoldingOwner({...e, myinfo: new MyInfo({...foundUser?.myinfo, mobile_no:"", email: ""})});
        return new_holding_owner;
      }
      else{
        return e;
      }
    })
    holdingSetFormValue({...holdingFormValues, holding_owners: [...newHoldingOwners]});
  },[holdingFormValues, holdingSetFormValue]);

  const documentList = useMemo(() => {
      return shared_documents_list.filter(item => applicationStep4FormData.file_items.some(doc => doc.code === item.code));
  }, [applicationStep4FormData.file_items])

  const isBtnValid = useMemo(():boolean => {
    return ReviewEndorseFormValid && holdingFormValid;
  },[ ReviewEndorseValues, ReviewEndorseFormValid, holdingFormValid ]);

  const firstOwnerName = useMemo(():string=>{
    return (isArray(applicationStep1FormData.household.incoming_owners) && size(applicationStep1FormData.household.incoming_owners) > 0) ? applicationStep1FormData.household.incoming_owners[0].myinfo?.name! : "";
  },[applicationStep1FormData])
  
  useEffect(()=>{
    AppDispatch(updateStageASuccess(true));
  },[AppDispatch]);
  
  useEffect(()=>{
    //NOTE: this to bypass step 4 for localhost.
    // if(!step_4){
    //   navigate('/application-coo/stage-a/declaration')
    // }
  },[step_4, navigate])
  
  useInitialWindowScrollTo();

  /**
   * 
   * @description this function is to update the holding form values with updated contact information and dispatch to the application 1 data.
   * @returns ApplicationStep1 data.
   */
  const updateApplicationStep1FormData = useCallback(async () =>{

    return await new Promise((resolve)=>{
      let currentStep1Value = new ApplicationStep1(applicationStep1FormData); 
  
      let formattedLatestHoldingOwner = currentStep1Value.household.incoming_owners.map(owner =>{
        //NOTE : holdingFormValues.holding_owners will always show one only, because we only show "L1" Role;
        let matchOwner = holdingFormValues.holding_owners.find(e=>e.myinfo.uinfin === owner.myinfo.uinfin);
        return matchOwner ? new Owner(matchOwner) : new Owner(owner);
      })
      
      let formattedLatestHoldingOccupier = currentStep1Value.household.incoming_occupiers.map(occupier =>{
        //NOTE : holdingFormValues.holding_owners will always show one only, because we only show "L1" Role;
        let matchOccupier = holdingFormValues.holding_occupiers.find(e=>e.myinfo.uinfin === occupier.myinfo.uinfin);
        return matchOccupier ? new Occupier(matchOccupier) : new Occupier(occupier);
      })
  
      let formattedCurrentOwner = currentStep1Value.household.owners.map(owner =>{
        let matchOwner = holdingFormValues.holding_owners.find(e=>e.myinfo.uinfin === owner.myinfo.uinfin);
        return matchOwner ? new Owner(matchOwner) : new Owner(owner);
      })
     
      let formattedCurrentOccupier = currentStep1Value.household.occupiers.map(occupier =>{
        //NOTE : holdingFormValues.holding_owners will always show one only, because we only show "L1" Role;
        let matchOccupier = holdingFormValues.holding_occupiers.find(e=>e.myinfo.uinfin === occupier.myinfo.uinfin);
        return matchOccupier ? new Occupier(matchOccupier) : new Occupier(occupier);
      })
  
      //Compare current household incoming owners and compare with L1 holding owner. Then make it to complete holding owners;
      let newStep1Value = new ApplicationStep1({reason: currentStep1Value.reason, household:{...currentStep1Value.household, incoming_owners: formattedLatestHoldingOwner, incoming_occupiers: formattedLatestHoldingOccupier, owners: formattedCurrentOwner, occupiers: formattedCurrentOccupier}})
      AppDispatch(updateApplicationStep1FormDataThunk({data: newStep1Value})).then(res=>{
        resolve(res.payload);
      });
    })
  },[AppDispatch, applicationStep1FormData, holdingFormValues.holding_occupiers, holdingFormValues.holding_owners])

   useEffect(() => {
    const owners = applicationStep1FormData.household.owners;
    const incomingOwners = applicationStep1FormData.household.incoming_owners;

    const checkOutgoingOwners = owners.filter((item) =>
      !incomingOwners.some((owner) => owner.myinfo.uinfin === item.myinfo.uinfin)
    );

    setOutgoingOwnersRepresentedState(
      checkOutgoingOwners.map((item) => {
        return {
          owner: item,
          is_represented: checkOutgoingOwners?.length === 1 ? true : undefined,
        };
      })
    );
  }, [applicationStep1FormData]);

  const isOutgoingSelectionRequired = useMemo(() => {
    if (
      applicationStep1FormData.reason.submit_content === false &&
      applicationStep1FormData.reason.change_ownership_reason ===
        OwnershipReasonEnum.divorce &&
      outgoingOwnersRepresentedState.length === 1
      && outgoingOwnersRepresentedState[0].owner.myinfo.uinfin !== loginUser.uinfin
    ) {
      ReviewEndorseSetFormValue({
        ...ReviewEndorseValues,
        outgoing_owner_represented: new Owner(
          outgoingOwnersRepresentedState[0].owner
        ),
      });
    }

    return (
      applicationStep1FormData.reason.submit_content === false &&
      applicationStep1FormData.reason.change_ownership_reason ===
        OwnershipReasonEnum.divorce &&
      outgoingOwnersRepresentedState.length > 1
    );
  }, [applicationStep1FormData, outgoingOwnersRepresentedState]);

  const submitCoo = useCallback(async():Promise<any> => {
      setIsSubmitting(true);

      let cooObj = new CooSubmission();
      let submittingSchemeType = schemeType ? schemeType : SchemeTypeEnum.public_applicant;
      const allowBypass35YearsOldCheck = checkNeedBypass35YearsOld(applicationStep1FormData.household, applicationStep1FormData.reason);
      if(allowBypass35YearsOldCheck){
        const currentSchemeType = applicationStartFormData?.selected_hdb_property?.eligibility_scheme_code?.toLowerCase();
        submittingSchemeType = currentSchemeType ? currentSchemeType : SchemeTypeEnum.public_applicant;
      }
      cooObj.setMainApplicantUinfin(loginUser.uinfin);
      cooObj.setApplicationStartForm(applicationStartFormData);
      cooObj.setSchemeType(submittingSchemeType);
      cooObj.setApplicationStep1Form({...applicationStep1FormData, reason: {...applicationStep1FormData.reason, registrar_uinfin: ReviewEndorseValues?.outgoing_owner_represented?.myinfo?.uinfin ?? ""}});
      cooObj.setApplicationStep2Form(applicationStep2FormData);
      cooObj.setApplicationStep3Form(applicationStep3FormData);
      cooObj.setApplicationStep4Form(applicationStep4FormData);
      cooObj.setApplicationStep5Form(ReviewEndorseValues);
      cooObj.setOutgoingOwnerRepresented(ReviewEndorseValues?.outgoing_owner_represented?.myinfo?.uinfin ?? "");
      cooObj.mapMainApplicantToOwnerPayload(holdingFormValues);


      //NOTE: disabled this to debug declaration form empty fields after click submit
      // updateApplicationStep1FormData();
      await PolymerAxios(loginUser?.uinfin ?? "", singpassToken).post(API_EligibilityDebugLog, {
        application_uuid: `${loginUser?.uinfin} - ${applicationId} - A5 submit payload`,
        message: JSON.stringify({...cooObj.getJson(), application_id: applicationId})
      });
      await PolymerAxios(loginUser?.uinfin ?? "", singpassToken).post(API_ApplicationSubmit, {...cooObj.getJson(), application_id: applicationId})
    }
    ,[loginUser.uinfin, applicationStartFormData, applicationStep1FormData, ReviewEndorseValues, applicationStep2FormData, applicationStep3FormData, applicationStep4FormData, holdingFormValues, singpassToken, applicationId, schemeType]);

  const isToIncludeValuation = useMemo(()=>{
    const isProposedHDBLoan = applicationStep2FormData.new_loan_type === LoanTypeEnum.hdb_loan;
    const isResale = checkIsFlatResale(applicationStartFormData.selected_hdb_property?.financing_info.sales_type_code!);
    const isValuationHDB = applicationStep3FormData.valuation === StampDutyValuationEnum.hdb;

    if(isValuationHDB || (isResale && isProposedHDBLoan)){
      return true;
    }
    return false
  },[applicationStep2FormData.new_loan_type, applicationStep3FormData.valuation, applicationStartFormData.selected_hdb_property?.financing_info.sales_type_code]);

  const submitApplication = useCallback(() => {
    if(ReviewEndorseFormValid){
      if (customWindow.wogaaCustom) {
        customWindow.wogaaCustom.completeTransactionalService(stageATrackingId);
      }
      submitCoo().then(res=>{
        try{
          const consentObj = new CooGiveConsent();
          if(applicationId){
            consentObj.setApplicationId(applicationId);
          }
          consentObj.setGiveConsent(true);
          const submitFinancing : SubmitFinancing = {
            ...applicationStep2FormData,      
            current_loan_amount: Number(applicationStep2FormData.current_loan_amount),
            current_loan_type: applicationStep2FormData.current_loan_type?.toString() ?? "",
            new_loan_type: applicationStep2FormData.new_loan_type?.toString() ?? "",
          }
          consentObj.setFinancingInfo(new SubmitFinancing(submitFinancing))
          consentObj.setConveyancing(new StageBConveyancing({...applicationStep3FormData}));
          consentObj.setHoldingValuesToOwnerObj(holdingFormValues);

          const transactionTypes: string[] = [];
          if(!bypassPayments.admin) {
            transactionTypes.push("admin");
          }
  
          if(!bypassPayments.valuation && isToIncludeValuation) {
            transactionTypes.push("valuation");
          }
          
          PolymerAxios(loginUser?.uinfin ?? "", singpassToken)
            .patch(`${API_StartConsent}?applicationUuid=${applicationId}`)
            .then(() =>
              PolymerAxios(loginUser?.uinfin ?? "", singpassToken).post(API_GiveConsent, {
                ...consentObj.getGiveConsentJSON(),
                application_uuid: consentObj.application_uuid,
                transaction_types: transactionTypes
              })
            )
            .then(() => {
              AppDispatch(updateFormData({ ...ReviewEndorseValues, holding_form_values: holdingFormValues }));
              navigate("/application-coo/stage-a/success");
            })
            .catch((e) => {
              console.log("CATCH GiveConsent API");
              alert("give consent API failed");
            });
        }catch(error) {
          console.log("CATCH Pre-GiveConsent API",error);
          alert("give consent OBJ failed");
        }
      }).catch(e=>{
        console.log("CATCH submitAPI", e);
        PolymerAxios(loginUser?.uinfin ?? "", singpassToken).post(API_EligibilityDebugLog, {
          application_uuid: `${loginUser?.uinfin} - ${applicationId} - A5 submit fail error`,
          message: JSON.stringify(e)
        });
        alert("submit API failed");
      }).finally(()=>{
        setIsSubmitting(false);
      });
    }
  },[ReviewEndorseFormValid, submitCoo, applicationId, applicationStep2FormData, applicationStep3FormData, holdingFormValues, loginUser?.uinfin, singpassToken, AppDispatch, ReviewEndorseValues, navigate, bypassPayments, isToIncludeValuation])

  useEffect(()=>{
    if(applicationStep5FormData.holding_form_values?.holding_owners?.length > 0){
      holdingSetFormValue({...applicationStep5FormData.holding_form_values});
    }else if(applicationStep1FormData.household){
      let initHoldingFormData = new InitIncomingToHoldingFormData(applicationStep1FormData?.household);
      holdingSetFormValue(new HoldingFormData(initHoldingFormData.generateHoldingFormOwnerMainApplicantOnly(loginUser?.uinfin, applicationStartFormData.selected_hdb_property)));
    }
    ReviewEndorseSetFormValue({...applicationStep5FormData});
  },[applicationStep1FormData, holdingSetFormValue, loginUser, applicationStep5FormData, ReviewEndorseSetFormValue, applicationStartFormData])

  useEffect(()=>{
    //INIT commonTenancy,
  },[initApplicationStep5FormData])
  

  const saveDraft = useCallback(async(requiredAlert: boolean) => {
    const response = await performSaveDraft(ReviewEndorseValues,5, applicationId, singpassToken);
    if(requiredAlert){
      setSaveDraftSuccess(response);
    }
  }, [ReviewEndorseValues, applicationId, applicationStep1FormData, performSaveDraft, singpassToken])
  
  const saveDraftManual = useCallback(async(requiredAlert: boolean, data:any, holdingFormValues: HoldingFormData) => {
    const response = await performSaveDraftManual({applicationStart: applicationStartFormData, applicationStep1: data, applicationStep2: applicationStep2FormData, applicationStep3: applicationStep3FormData, applicationStep4: applicationStep4FormData, applicationStep5: ReviewEndorseValues, applicationId, singpassToken, holdingFormValues});
    if(requiredAlert){
      setSaveDraftSuccess(response);
    }
  }, [ReviewEndorseValues, applicationId, applicationStartFormData, applicationStep2FormData, applicationStep3FormData, applicationStep4FormData, performSaveDraftManual, singpassToken])
  
  useEffect(() => {
    if(saveDraftSuccess){
        setTimeout(() => {
            setSaveDraftSuccess(false);
        }, 3000)
    }
  }, [saveDraftSuccess])


  const saveDraftLeavePage = useCallback(async()=>{
    await saveDraft(false);
  },[navigate, saveDraft])

  const navigateBack = useCallback(()=>{
    navigate("/application-coo/stage-a/upload-documents")
  },[navigate])

  const handleSetDeclarationCheckbox = useCallback(() => {
      ReviewEndorseSetFormValue({...ReviewEndorseValues, input_verified: !ReviewEndorseValues.input_verified})
  },[ReviewEndorseValues,ReviewEndorseSetFormValue])

  const handleUnbindMyInfo = useCallback((nric:string)=>{
    onUnBindOwnerMyInfoToHolding(nric)
  },[onUnBindOwnerMyInfoToHolding])

  const toggleSaveDraftModal = useCallback(() => {
    setSaveDraftModalOpen((prev) => !prev);
  }, [saveDraftModalOpen])

  const handleSaveDraftClick = useCallback(async()=>{
    AppDispatch(updateFormData({...ReviewEndorseValues, holding_form_values: holdingFormValues}));
    updateApplicationStep1FormData().then((res:any)=>{
      saveDraftManual(true,res, holdingFormValues);
      setSaveDraftModalOpen(false);
    });
  },[AppDispatch, ReviewEndorseValues, holdingFormValues, updateApplicationStep1FormData, saveDraft])

  const handleCompleteClick = useCallback(async()=>{
    if(isOutgoingSelectionRequired){
      setRegistrarModalOpen(true);
    }else{
      submitApplication();
    }
  },[submitApplication, isOutgoingSelectionRequired])

  
  const handleRegistrarOnBack = useCallback(()=>{
    ReviewEndorseSetFormValue({...ReviewEndorseValues, outgoing_owner_represented: undefined});
    setRegistrarModalOpen(false);
  },[ReviewEndorseSetFormValue, ReviewEndorseValues])


  const handleRegistrarSetRepresentation = useCallback((value: OutgoingOwnerRepresentedState[])=>{
    setOutgoingOwnersRepresentedState(value);
    const outgoingOwnersRepresented = value.filter(item => item.is_represented === true);
    if(outgoingOwnersRepresented.length === 1){
        ReviewEndorseSetFormValue({...ReviewEndorseValues, outgoing_owner_represented: new Owner(outgoingOwnersRepresented[0].owner)});
    }else{
        ReviewEndorseSetFormValue({...ReviewEndorseValues, outgoing_owner_represented: undefined});
    }
  },[ReviewEndorseSetFormValue, ReviewEndorseValues]);

  const removeApplication = useCallback(async () => {
    if(applicationId){
      try {
        await PolymerAxios(loginUser?.uinfin ?? "", singpassToken)
          .post(`${API_ApplicationRemove}/${applicationId}`)
          .then((res) => res.data);
      } catch (error) {
        console.log(error);
      }
    }
  }, [singpassToken, applicationId, loginUser]);

  const saveValuesAndGoBack = useCallback(() => {
    AppDispatch(updateFormData({...ReviewEndorseValues, holding_form_values: holdingFormValues}));
    AppDispatch(setBackTriggered(true));
    navigateBack();
  }, [ReviewEndorseValues, holdingFormValues, navigateBack])

  return (
  
    <ApplicationCooLayout>
      <div className='polymer-application-coo__wrapper'>
        <div>
          <TextSubheader
            subheaderMain="Stage A: Start Application"
            subheaderSub={applicationStartFormData.selected_hdb_property?.address}
            paddingLeftRight={42}
          />
        </div>

        <Stepper activeStep={activeStep} items={stepperItems} style={{margin:"62px auto"}}/>
        
        <div className='d-flex justify-content-center polymer-stage-a5-section-card'>
          <SectionCard 
            disabled={isSubmitting}
            className='flex-fill' 
            required={false}
            titleChildren={
             <><StepperItem step={"5"} variant='active' size={40}/><P2TextDescription title={stepperItems[activeStep - 1]?.title}/></>
            } 
            contentChildren={
              <div>
                <div className='px-4 pb-5'>
                 
                  <ReviewHouseholdStructureTable isMainOutgoing={loginUserStructureStatus === StructureStatusEnum.outgoing} headerSeparatorVariant='dashed'/>

                {/* Proposed holding type  */}
                  <div style={{marginTop:32}}>
                    <P2TextDescription color='#000' title='Proposed Household Details'/>
                    <div className='mt-4 d-flex flex-column gap-3'>
                      <TextInfo variant='column' title={"Proposed Holding Type"} titleWeight="700" description={
                        <>
                          <div style={{ marginTop: 5, fontWeight: 400, marginBottom: applicationStep3FormData.holding_type === HoldingTypeEnum.tenancy_in_common ? 16 : 0}}>
                            {applicationStep3FormData.holding_type === HoldingTypeEnum.sole_ownership && "Sole Ownership"}
                            {applicationStep3FormData.holding_type !== HoldingTypeEnum.sole_ownership && proposedHousingTypeItems.find(e=>e.value === applicationStep3FormData.holding_type)?.title}
                          </div>
                          {applicationStep3FormData.holding_type === HoldingTypeEnum.tenancy_in_common && <TenancyInCommonTable tenancyData={applicationStep3FormData.tenancy_in_common}/>}
                        </>
                      } />
                    </div>
                    {/* Owners and Occupiers  */}
                    <div style={{marginTop:16,marginBottom: 8}}>
                      <P2TextDescription size='18px' color='#000' title={"Owners"}/>
                    </div>
                    <div style={{display:"flex", gap:8, flexDirection:"column"}}>
                      {
                        applicationStep1FormData.household.incoming_owners?.map((owner,_index)=>{
                          const is_first_owner = _index === 0;
                          return <OwnerOrOccupierReviewAccordion isOwner={true} first_person={firstOwnerName} is_first_person={is_first_owner} key={owner.myinfo?.uinfin} person={owner}/>
                        })
                      }
                    </div>
                    
                    {applicationStep1FormData.household.incoming_occupiers && applicationStep1FormData.household.incoming_occupiers.length > 0 && <>
                      <Separator style={{margin:"32px 0"}}/>
                      <div style={{marginBottom: 8}}>
                        <P2TextDescription size='18px' color='#000' title={"Occupiers"}/>
                      </div>
                      <div style={{display:"flex", gap:8, flexDirection:"column"}}>
                        {
                          applicationStep1FormData.household.incoming_occupiers?.map(occupier=>{
                            return <OwnerOrOccupierReviewAccordion isOwner={false} first_person={firstOwnerName} key={occupier.myinfo?.uinfin} person={occupier}/>
                          })
                        }
                      </div>
                    </>}

                  </div>
                </div>
                <Separator variant='solid'/>

                
                {/* 4. Documents */}
                {applicationStep4FormData.file_items.length > 0 && <>
                  <ReviewDocument document_list={documentList} file_items={applicationStep4FormData.file_items} submitted_documents_code={applicationStep4FormData.file_items.map(file => file.code)}/>
                  <Separator variant='solid'/>
                </>}

                <Declaration checkboxValue={ReviewEndorseValues?.input_verified} setCheckboxValue={handleSetDeclarationCheckbox}/>

                {/* 5. Contact Detail */}
                <ReviewContactDetails proposed_owners={holdingFormValues.holding_owners} proposed_occupiers={holdingFormValues.holding_occupiers} holdingFormValues={holdingFormValues} holdingSetFormValue={holdingSetFormValue} holdingFormErrors={holdingFormErrors} onBindMyInfo={onBindOwnerMyInfoToHolding} onUnBindMyInfo={handleUnbindMyInfo}/>

                {/* <Separator variant='solid'/>
               
                <div className='px-4 pt-4'>
                  <P2Checkbox variant={"default"} isActive={ReviewEndorseValues?.input_verified} onClick={() => {
                    ReviewEndorseSetFormValue({ ...ReviewEndorseValues, input_verified: !ReviewEndorseValues.input_verified });
                  }} description={<P2TextLabel label={<span className='m-0'>I have verified that all the inputs provided is correct.</span>}/>} />
                </div> */}
              </div>
            }
          />
        </div>

        <Separator style={{margin:"32px 42px"}}/>

        <div className='polymer-shared-alert-container'>
          <div style={{ marginTop: 24, marginBottom: 24 }}>
            {saveDraftSuccess && <SaveDraftAlert/>}
          </div>
        </div>
        
        <div className='polymer-application-coo__card-button'>
          <P2ButtonGroup>
            <P2Button variant={"outline-primary"} onClick={saveValuesAndGoBack}>Back</P2Button>
            <P2Button variant={"outline-primary"} onClick={toggleSaveDraftModal}>Save as draft</P2Button>
            <P2Button variant={"primary-1"} onClick={handleCompleteClick} disabled={(!isBtnValid || isSubmitting)}>{isSubmitting ? "Processing" : "Complete application"}</P2Button>
          </P2ButtonGroup>
        </div>
        {isOutgoingSelectionRequired&& (
          <DivorceRegistrarRepresentation
            modalOpen={registrarModalOpen}
            outgoingOwnersRepresented={outgoingOwnersRepresentedState}
            setOutgoingOwnersRepresented={handleRegistrarSetRepresentation}
            onSubmit={submitApplication}
            onBack={handleRegistrarOnBack}
          />
        )}
        <SaveDraftModal onSubmit={handleSaveDraftClick} onCancel={removeApplication} onClose={toggleSaveDraftModal} isOpen={saveDraftModalOpen}/>

        <LeavingPageModal 
          onSubmit={saveDraftLeavePage}
          onCancel={removeApplication}
          requireConfirmationOnBack={false}
          reviewEndorseValues={ReviewEndorseValues}
        /> 
      </div>
    </ApplicationCooLayout>

      
  )
}

export default ApplicationCOOStep5

